var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters justify-content-center h-100"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('BQdtCard',{attrs:{"name":"turnoverDim","type":"top-menu-item"}})],1),_c('div',{staticClass:"col-sm-12 col-md"},[_c('BQdtCard',{attrs:{"name":"turnoverMes","type":"top-menu-item"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }